import React, { Component } from 'react';

// import SideBar from "../../../components/admin/side";
import ResourceFacet from "../../../components/resource/admin/list/facet";
import SearchBox from '../../../components/resource/admin/list/search';
import ResourceItem from '../../../components/resource/admin/list/item'
import * as func from "../../../utils/functions";
import JournalItem from "../../../components/journal/admin/list/item";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "../../../store/modules/resources";
import {PropTypes} from "prop-types";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import FrontFooter from '../../../components/etc/footer/';
import {BASE_PATH} from "../../../wpconfig";

class Resources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInit: false,
      action : 'admin/resources',
      url : 'wp-admin/admin.php?page=resource&',
    }
  }

  componentDidMount() {
    if(location.search.substring(1)) {
      this.props.dataActions.setResources({'param' : func.parseParams(location.search.substring(1))});
    }
    // 이해 안됨.
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  getList() {
    func.getData(this.state.action, this.props.param).then((response) => {
      this.setState({
        isInit: true,
      })
      this.props.dataActions.setResources(response);
    });
  }

  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.props.param;
    param['current_page'] = paged;

    const {dataActions} = this.props;
    dataActions.setResources({"param": param});

    func.getData(this.state.action, param).then((response) => {
      response.checkedRecords = []
      this.props.dataActions.setResources(response);

      const url = objectToQueryString(this.props.param);
      pushUrl('검색', "admin.php?page=resource&" + url, this.props.param);
    });
  }

  order = (key) => {
    let param = this.props.param;
    if(param.order_by === key) {
      if (param.order === 'asc')
        param.order = 'desc'
      else
        param.order = 'asc'
    } else {
      param.order_by = key
      param.order = 'desc'
    }

    const {dataActions} = this.props;
    dataActions.setResources({"param": param});

    func.getData(this.state.action, param).then((response) => {
      response.checkedRecords = []
      this.props.dataActions.setResources(response);

      const url = objectToQueryString(this.props.param);
      pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
    });
  }

  onRecordCheck = () => {
    const checkedRecords = this.props.checkedRecords;
    if (event.target.checked) {
      checkedRecords.push(event.target.value)
      this.props.dataActions.setResources({checkedRecords : checkedRecords});
    } else {
      const idx = checkedRecords.indexOf(event.target.value)
      if (idx > -1) checkedRecords.splice(idx, 1)
      this.props.dataActions.setResources({checkedRecords : checkedRecords});
    }
    this.forceUpdate()
  }

  compareArray = function(a, b){
    if(JSON.stringify(a) === JSON.stringify(b)) {
      return true;
    } else{ return false; }
  }

  isAllChecked () {
    let recordsId = [];
    this.props.records.map((record, index) => {
      recordsId.push(record.resource_id)
    })
    let checkedRecordsId = this.props.checkedRecords;

    let nameSort = function(a,b){
      if(a < b){
        return -1
      }else if(a > b){
        return 1;
      }else{
        return 0;
      }
    }

    recordsId.sort(nameSort);
    checkedRecordsId.sort(nameSort);

    return this.compareArray(recordsId, checkedRecordsId)
  }

  onAllRecordCheck = () => {
    const checkedRecords = [];
    if (event.target.checked) {
      {this.props.records.map((record, index) => {
        checkedRecords.push(record.resource_id)
      })}
    }
    this.props.dataActions.setResources({checkedRecords : checkedRecords});
    this.forceUpdate()
  }

  render() {
    const { isInit } = this.state;
    const { records } = this.props;

    const allChecked = this.isAllChecked()
    return (
      <div className="container-fluid mt-3 admin-layout">
        <div className="row">
          <div className="admin-sidebar">
            <ResourceFacet />
          </div>
          <div className="col admin-contents">
            <SearchBox />

            {/* <div className="form-row ml-2 mb-2">
              <div className="btn-group" role="group" aria-label="Basic example">
                <button type="button" className="btn btn-secondary btn-sm">신규</button>
                <button type="button" className="btn btn-secondary btn-sm">알림발송</button>
                <button type="button" className="btn btn-secondary btn-sm">다운로드</button>
                <button type="button" className="btn btn-secondary btn-sm">삭제</button>
              </div>
            </div> */}
            <table className="table table-striped table-thin border-bottom resource-list">
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" className="ml-0"
                                         checked={allChecked}
                                         onChange={this.onAllRecordCheck} /></th>
                  <th scope="col">NO</th>
                  <th scope="col">ID</th>
                  <th scope="col">논문<br />유형</th>
                  {/* <th scope="col">원문<br />PRE/PDF</th> */}
                  <th scope="col">논문명</th>
                  <th scope="col">저널명</th>
                  <th scope="col">저자수</th>
                  <th scope="col">발행년도</th>
                  <th scope="col" className="pl-0 pr-0 ml-0 mr-0">
                    <span className="btn btn-outline-dark db-check-title">SE</span>
                    <span className="btn btn-outline-dark db-check-title">SS</span>
                    <span className="btn btn-outline-dark db-check-title">AH</span>
                    <span className="btn btn-outline-dark db-check-title">ES</span>
                    <span className="btn btn-outline-dark db-check-title">SP</span>
                    <span className="btn btn-outline-dark db-check-title">NA</span>
                    <span className="btn btn-outline-dark db-check-title">KC</span>
                    <span className="btn btn-outline-dark db-check-title">KG</span>
                    <span className="btn btn-outline-dark db-check-title">KD</span>
                  </th>
                  <th scope="col">상태</th>
                  <th scope="col">입력일/수정일</th>
                </tr>
              </thead>
              <tbody>
                {!isInit && records.length <= 0 && <tr><td colSpan={15}>로딩중입니다.</td></tr>}
                {isInit && records.length <= 0 && <tr><td colSpan={15}>결과가 없습니다.</td></tr>}
                {records.map((record, index) => {
                  const no = this.props.totalRecords - ((this.props.param.current_page - 1) * this.props.param.record_per_page) - index;
                  const checked = this.props.checkedRecords.includes(record.resource_id)
                  return (
                    <ResourceItem key={index} record={record} no={no} onRecordCheck={this.onRecordCheck}
                                  checked={checked}
                    />
                  )
                })}
              </tbody>
            </table>
            {this.props.totalPage > 1 &&
            <div className="mt-4">
              <div>
                <div className="paging-wrap">
                  <ReactPaginate
                      forcePage={Number(this.props.param.current_page)-1}
                      pageCount={this.props.totalPage}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      activeClassName={'active'}
                      pageClassName={'page-item'}
                      pageLinkClassName={'page-link'}
                      previousClassName={'page-item page-item-prev'}
                      previousLinkClassName={'page-link'}
                      nextClassName={'page-item page-item-next'}
                      nextLinkClassName={'page-link'}
                  />
                </div>
              </div>
            </div>
            }
          </div>
        </div>
				<FrontFooter
					param={this.props.param}
					facet={this.props.facet}
					dataActions={this.props.dataActions} />
      </div>
    )
  }
}


export default connect(
    (state) => ({
      param: state.resources.param ? state.resources.param : {},
      records : state.resources.records ? state.resources.records : [],
      checkedRecords : state.resources.checkedRecords ? state.resources.checkedRecords : [],
      facet : state.resources.facet ? state.resources.facet : {},
      totalRecords : state.resources.totalRecords ? state.resources.totalRecords : 0,
      totalPage : state.resources.totalPage ? state.resources.totalPage : 0,
    }),
    (dispatch) => ({
      dataActions: bindActionCreators(Actions, dispatch)
    }),
)(Resources)

Resources.propTypes = {
  param : PropTypes.object,
  records : PropTypes.array,
  checkedRecords : PropTypes.array,
  facet : PropTypes.object,
  totalRecords : PropTypes.number,
  totalPage : PropTypes.number,
};
